module.exports = __webpack_public_path__ + "d5430cc9df39362db82c076ce712d158.png";